
/**
 * This is an abstract class because we need it to still be a valid token for dependency injection after transpiling.
 * This does not mean you should extend it, simply implementing it is fine.
 * @abstract
 */
export abstract class LoadingListener {
/**
 * @abstract
 * @return {?}
 */
startLoading() {}
/**
 * @abstract
 * @return {?}
 */
doneLoading() {}
}